import React from 'react'
import Form from "../Form/Form";
import useStyles from './style'



export const Modal = ({currentId,setCurrentId,setView,setCreateview}) => {
    const classes=useStyles()
    console.log("from modal",currentId)
    
  return (
     <div className={classes.Wrapper}>
    <div className={classes.modal2}>
      <div className={classes.modalcontent}>
      <Form currentId={currentId} setCurrentId={setCurrentId} setView={setView} setCreateview={setCreateview}/>
      </div>
      </div>
    </div>
  )
}
